import React from "react"

const Item8 = () => {
  return (
    <React.Fragment>
      <h2 className="regular-23 bold">Pasos:</h2>
      <ol className="ml-16">
        <li><p className="regular-parraf">Si realizaste tú pago desde la plataforma, deberías de tener acceso automáticamente</p></li>
        <li><p className="regular-parraf">Si tu pago fue por otro medio, envíanos screenshot o foto de la acreditación de tu pago y nosotros te damos el acceso</p></li>
        <li><p className="regular-parraf">Comienza a prepar tu ENARM.</p></li>
      </ol>
    </React.Fragment>
  )
}

export default Item8;